import { memo, FC, Dispatch, SetStateAction, useMemo } from 'react'
import { Flex, FlexProps, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'

import { ProfessionalContractTypeFilterKeyString } from 'InstitutionalManagement/types'
import { RefreshButton } from 'components'
import { PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/professionalContractTypes'
import { getProfessionalContractTypeFilterFeedbacks } from 'InstitutionalManagement/utils/getProfessionalContractTypeFilterFeedbacks'

type Props = FlexProps & {
  professionalContractTypeFilter: ProfessionalContractTypeFilterKeyString
  setProfessionalContractTypeFilter: Dispatch<SetStateAction<ProfessionalContractTypeFilterKeyString>>
}

const ProfessionalContractTypeFilterTags: FC<Props> = ({
  professionalContractTypeFilter,
  setProfessionalContractTypeFilter,
  ...flexProps
}) => {
  const filtersWithValue = useMemo(() => {
    return Object.entries(professionalContractTypeFilter).filter(([key]) => {
      return professionalContractTypeFilter[key] !== PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER[key]
    })
  }, [professionalContractTypeFilter])

  function resetFilterByKey(key: string) {
    setProfessionalContractTypeFilter({
      ...professionalContractTypeFilter,
      [key]: PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER[key],
    })
  }

  function resetAllFilters() {
    setProfessionalContractTypeFilter(PROFESSIONAL_CONTRACT_TYPE_INITIAL_FILTER)
  }

  function setFilterFeedbackInTagByKey(key: string, value: string) {
    const filterTagFeedbacks: ProfessionalContractTypeFilterKeyString =
      getProfessionalContractTypeFilterFeedbacks(value)
    return filterTagFeedbacks[key]
  }

  if (filtersWithValue.length === 0) return null

  return (
    <Flex align="center" flexWrap="wrap" gap={2} {...flexProps}>
      {filtersWithValue.map(([key, value]) => (
        <Tag key={key} variant="filter-tags">
          <TagLabel>{setFilterFeedbackInTagByKey(key, value)}</TagLabel>
          <TagCloseButton onClick={() => resetFilterByKey(key)} />
        </Tag>
      ))}

      <RefreshButton onClick={resetAllFilters}>Limpar filtros</RefreshButton>
    </Flex>
  )
}

export default memo(ProfessionalContractTypeFilterTags)
